export enum RouteKeys {
  List = '/subscription-plan',
  New = '/subscription-plan/new',
  Edit = '/subscription-plan/:id',
  EditCategory = '/subscription-plan/:id/edit-category',
}
